import { displayTextLabelValidator, nonEmptyStringValidator } from '@vista/omnichannel-components-domain';
import { Validator } from '@vista-digital/validator';
/**
 * Default display text for the Ticket Picker component.
 */
export const defaultTicketPickerDisplayText = {
    counterLabel: 'Tickets have been chosen',
    tableColumnItemHeaderLabel: 'Item',
    tableColumnPriceHeaderLabel: 'Price',
    tableColumnQuantityHeaderLabel: 'Quantity',
    tableColumnSubtotalHeaderLabel: 'Subtotal',
    errorTooManyTicketsSelectedMessage: 'You have too many tickets. Remove tickets or add more seats to your order.',
    errorTooFewTicketsSelectedMessage: 'Your selected tickets count is less than the seats count.',
    errorTicketsDoNotMatchAreaCategoriesMessage: 'Your selected tickets do not match your selected seats.',
    errorNoTicketsSelectedMessage: 'You must select at least one ticket.',
    failedToLoadDataTitle: 'Sorry, something went wrong.',
    failedToLoadDataMessage: 'Refresh your browser to try loading ticket options again.',
    includedBookingFeeFormat: 'includes booking fee of ${bookingFee}',
    excludedBookingFeeFormat: 'plus booking fee of ${bookingFee}',
    errorFailedToSaveTitle: 'Failed to save ticket selection!',
    errorFailedToSaveMessage: 'Refresh your browser to try saving again.',
    errorInsufficientSeatsAvailableTitle: 'Not enough seats left!',
    errorInsufficientSeatsAvailableMessage: "Sorry, it looks like we don't have enough seats left in this showtime. Please adjust your order or try another showtime.",
    ticketSingleUseRedemptionDetailsFormat: '${formattedCodeDetails}',
    ticketMultiUseRedemptionDetailsFormat: '${formattedCodeDetails} (${remainingRedemptions}/${maximumRedemptions} remaining)',
    ticketUnlimitedUseRedemptionDetailsFormat: '${formattedCodeDetails}',
    ticketRedemptionCodeDetailsFormat: '${maskedCode}',
    ticketRedemptionCodeDetailsNamedFormat: '${formattedMemberName}'
};
export const ticketPickerDisplayTextValidator = Validator.object({
    counterLabel: nonEmptyStringValidator,
    tableColumnItemHeaderLabel: nonEmptyStringValidator,
    tableColumnPriceHeaderLabel: nonEmptyStringValidator,
    tableColumnQuantityHeaderLabel: nonEmptyStringValidator,
    tableColumnSubtotalHeaderLabel: nonEmptyStringValidator,
    errorTooManyTicketsSelectedMessage: nonEmptyStringValidator,
    errorTooFewTicketsSelectedMessage: nonEmptyStringValidator,
    errorTicketsDoNotMatchAreaCategoriesMessage: nonEmptyStringValidator,
    errorNoTicketsSelectedMessage: nonEmptyStringValidator,
    failedToLoadDataTitle: nonEmptyStringValidator,
    failedToLoadDataMessage: nonEmptyStringValidator,
    includedBookingFeeFormat: displayTextLabelValidator,
    excludedBookingFeeFormat: displayTextLabelValidator,
    errorFailedToSaveTitle: nonEmptyStringValidator,
    errorFailedToSaveMessage: nonEmptyStringValidator,
    errorInsufficientSeatsAvailableTitle: nonEmptyStringValidator,
    errorInsufficientSeatsAvailableMessage: nonEmptyStringValidator,
    ticketSingleUseRedemptionDetailsFormat: nonEmptyStringValidator,
    ticketMultiUseRedemptionDetailsFormat: nonEmptyStringValidator,
    ticketUnlimitedUseRedemptionDetailsFormat: nonEmptyStringValidator,
    ticketRedemptionCodeDetailsFormat: nonEmptyStringValidator,
    ticketRedemptionCodeDetailsNamedFormat: nonEmptyStringValidator
});
